export default __webpack_public_path__ + "static/media/Escada Rolante.7d2832ab.svg";